{
  "dismiss": "Пропустить"
}